import { IconName } from '@travelata-libs/ui-kit';
import { OperatorId } from '@entities/operator';

export const SQUARE_LOGO_OPERATOR_IDS = new Set<number>(OperatorId.Travelata);

export const OFFERS_WORD_FORMS = ['предложение', 'предложения', 'предложений'];

export const PARTNERS_WORD_FORMS = ['партнёра', 'партнёров', 'партнёров'];

export const PROVIDERS_MODAL_Z_INDEX = 10010;

export const FREE_CANCELLATION_LABEL_TEXT = 'Есть тарифы с бесплатной отменой';

export const PARTNER_REDIRECT_PATH = '/partner-redirect';

export const OFFER_CLICK_SEND_TIMEOUT_MS = 500;

export const CHECKOUT_REPEAT_CLICK_GUARD_MS = 1000;

export const TRUST_NOTE_TITLE = 'Всем продавцам можно доверять';
export const TRUST_NOTE_DESCRIPTION =
  'Мы проверяем каждого партнёра перед подключением. Если что-то пойдёт не так с бронированием — поможем разобраться.';

export const PROVIDER_BENEFITS = [
  { id: 'support', icon: IconName.Headset, text: 'Поддержка 24/7' },
  { id: 'instant-booking', icon: IconName.Bolt, text: 'Мгновенное бронирование' },
];
